import script from "./templateBigScreen4.vue?vue&type=script&setup=true&lang=js"
export * from "./templateBigScreen4.vue?vue&type=script&setup=true&lang=js"

import "./templateBigScreen4.vue?vue&type=style&index=0&id=1cd6e25f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cd6e25f"]])

export default __exports__